module.exports = __webpack_public_path__ + "static/media/carroussel_10.5acaebd9.jpg";